import {
  APIGatewayResponseDataHeader,
  APIGatewayResponse,
} from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { Entitlement } from '@dxb-web-ui-framework/iam/domain/AccessControl/entities';
import { PartyIdentification } from '../../../../../card/src/types';
import { PartyRole } from '../../../../../transaction/src/contexts/Parameters/types';

export enum PartyRelationshipEnum {
  ACCOUNTANT = 'ACCOUNTANT',
  HAS_ACCOUNTANT = 'HAS_ACCOUNTANT',
  TRUSTEE = 'TRUSTEE',
  HAS_TRUSTEE = 'HAS_TRUSTEE',
  AUTHORIZED_SIGNATORY = 'AUTHORIZED_SIGNATORY',
  HAS_AUTHORIZED_SIGNATORY = 'HAS_AUTHORIZED_SIGNATORY',
  CONSULTANT = 'CONSULTANT',
  HAS_CONSULTANT = 'HAS_CONSULTANT',
  CONTACT = 'CONTACT',
  HAS_CONTACT = 'HAS_CONTACT',
  DIRECTOR = 'DIRECTOR',
  HAS_DIRECTOR = 'HAS_DIRECTOR',
  HUSBAN_WIFE = 'HUSBAN_WIFE',
  HAS_HUSBAN_WIFE = 'HAS_HUSBAN_WIFE',
  ATTORNEY = 'ATTORNEY',
  HAS_ATTORNEY = 'HAS_ATTORNEY',
  CHILD = 'CHILD',
  PARENT_GUARDIAN = 'PARENT_GUARDIAN',
  PARENT_COMPANY = 'PARENT_COMPANY',
  SUBSIDIARY_COMPANY = 'SUBSIDIARY_COMPANY',
  CHAIRMAN = 'CHAIRMAN',
  HAS_CHAIRMAN = 'HAS_CHAIRMAN',
  MANAGER_OF_INCAPACITATED = 'MANAGER_OF_INCAPACITATED',
  HAS_MANAGER_OF_INCAPACITATED = 'HAS_MANAGER_OF_INCAPACITATED',
  MANAGER_OF_DECEASED = 'MANAGER_OF_DECEASED',
  HAS_MANAGER_OF_DECEASED = 'HAS_MANAGER_OF_DECEASED',
  REPRESENTATIVE = 'REPRESENTATIVE',
  HAS_REPRESENTATIVE = 'HAS_REPRESENTATIVE',
  SECRETARY = 'SECRETARY',
  HAS_SECRETARY = 'HAS_SECRETARY',
  SHAREHOLDER = 'SHAREHOLDER',
  HAS_SHAREHOLDER = 'HAS_SHAREHOLDER',
  BUSINESS_OWNER = 'BUSINESS_OWNER',
  HAS_BUSINESS_OWNER = 'HAS_BUSINESS_OWNER',
  UNKNOWN_RELATIONSHIP_PERSON = 'UNKNOWN_RELATIONSHIP_PERSON',
  UNKNOWN_RELATIONSHIP_ORGANIZATION = 'UNKNOWN_RELATIONSHIP_ORGANIZATION',
  BOARD_OF_DIRECTORS = 'BOARD_OF_DIRECTORS',
  HAS_BOARD_OF_DIRECTORS = 'HAS_BOARD_OF_DIRECTORS',
}

export type EntitlementsData = Entitlement[];

export type PartyRelationship = {
  type: PartyRelationshipEnum;
  relationshipName: string;
  partyIdentifications: PartyIdentification[];
  partyName: string;
  partyType: string;
};

export type PostLoginResponseBody = {
  partyIdentifications: PartyIdentification[];
  partyRelationships: PartyRelationship[];
  partyRoles: PartyRole[];
};

class PostLoginCardResponseDTO implements APIGatewayResponse<PostLoginResponseBody> {
  headers: APIGatewayResponseDataHeader[];
  body: PostLoginResponseBody;

  constructor(headers: APIGatewayResponseDataHeader[], body: PostLoginResponseBody) {
    this.body = body;
    this.headers = headers;
  }
}

export { PostLoginCardResponseDTO };
